export class ListAccreditationsFakeDb {
  public static accreditations = [
    {
      category: 'RSA Licence',
      credentials: [
        {
          accreditation: 'NSW Responsible Service of Alcohol',
          inputs: [
            {
              label: 'Licence Number',
              type: 'string'
            },
            {
              label: 'Expires At',
              type: 'date'
            },
            {
              label: 'Class',
              type: 'multi-choice-string',
              choices: [
                "Class A - Responsible Service of Alcohol",
                "Class G - Responsible Conduct of Gambling",
                "Class H - High Risk Venue Management",
                "Class P - Privacy Training"
              ]
            },
            {
              label: 'Tyoe',
              type: 'single-choice-string',
              choices: ['Card', 'Interim', 'Certificate']
            },
          ],
          type: '',
          validation: {
            success: {}
          },
          uuid: 'dfge48y534rt7yw784ryw784yr'
        },
        {
          accreditation: 'VIC Responsible Service of Alcohol',
          inputs: [
            {
              label: 'Licence Number',
              type: 'string'
            },
            {
              label: 'Expires At',
              type: 'date'
            }
          ],
          type: '',
          validation: {
            success: {}
          },
          uuid: '54t4e56te546746yrtgd54r'
        },
        {
          accreditation: 'QLD Responsible Service of Alcohol',
          inputs: [
            {
              label: 'Licence Status',
              type: 'single-choice-string',
              choices: [
                "Current",
                "Expired",
                "Cancelled",
                "Withdrawn",
                "Surrendered",
                "Suspended"
              ]
            }
          ],
          type: '',
          validation: {
            success: {}
          },
          uuid: '56ywerw3rw34taw34'
        },
        {
          accreditation: 'WA Responsible Service of Alcohol',
          inputs: [
            {
              label: 'Licence Status',
              type: 'single-choice-string',
              choices: [
                "Current",
                "Expired",
                "Cancelled",
                "Withdrawn",
                "Surrendered",
                "Suspended"
              ]
            }
          ],
          type: '',
          validation: {
            success: {}
          },
          uuid: '76frw3e4gt3e4gt45t5r'
        }
      ],
      id: '45678uhgfghjkhr567uiu'
    }
    // {
    //   name: "Licence",
    //   types: [
    //     {
    //       type: "Security",
    //       names: [
    //         "NSW Security Licence",
    //         "VIC Security Licence",
    //         "QLD Security Licence",
    //         "WA Security Number",
    //       ],
    //     },
    //     {
    //       type: "RSA Licence",
    //       names: [
    //         "NSW Responsible Service of Alcohol",
    //         "VIC Responsible Service of Alcohol",
    //         "QLD Responsible Service of Alcohol",
    //         "WA Responsible Service of Alcohol",
    //       ],
    //     },
    //     {
    //       type: "RCG Licence",
    //       names: [
    //         "NSW Responsible Conduct of Gambling",
    //         "VIC Responsible Service of Gaming",
    //         "QLD Responsible Service of Gambling",
    //       ],
    //     },
    //     {
    //       type: "RSA Privacy Licence",
    //       names: ["NSW Responsible Service of Alcohol"],
    //     },
    //     {
    //       type: "Liquor",
    //       names: [
    //         "NSW Liquor Licence",
    //         "QLD Liquor Licence",
    //         "WA Liquor Licence",
    //       ],
    //     },
    //     {
    //       type: "Other",
    //       names: ["Other"],
    //     },
    //   ],
    // },
    // {
    //   name: "Qualification",
    //   types: [
    //     {
    //       type: "Degree/Certificate",
    //       names: [
    //         "Name of Degree/Certificate",
    //         "Issuing Institution",
    //         "Year of Completion",
    //         "Status or Level",
    //       ],
    //     },
    //     {
    //       type: "Security Certificate",
    //       names: ["Certificate in Security Operations "],
    //     },
    //     {
    //       type: "Courses",
    //       names: [
    //         "Name of Course",
    //         "Issuing Institution",
    //         "Year of Completion",
    //         "Status or Level",
    //       ],
    //     },
    //   ],
    // },
    // {
    //   name: "Induction",
    //   types: [
    //     {
    //       type: "Name of Client / Venue Location",
    //       names: ["Details"],
    //     },
    //     {
    //       type: "Training / Induction / Certificate",
    //       names: ["Description and issuer"],
    //     },
    //   ],
    // },
    // {
    //   name: "Vaccination",
    //   types: [
    //     {
    //       type: "COVID-19",
    //       names: ["Medical Certificate"],
    //     },
    //   ],
    // },
    // {
    //   name: "Personal",
    //   types: [
    //     {
    //       type: "Driver Licence",
    //       names: ["Driver Licence"],
    //     },
    //     {
    //       type: "Traffic Control",
    //       names: ["Traffic Control"],
    //     },
    //     {
    //       type: "Life Saving",
    //       names: ["Royal Life Saving"],
    //     },
    //     {
    //       type: "Construction Card",
    //       names: ["General Construction Induction Card "],
    //     },
    //     {
    //       type: "Fire Safety",
    //       names: ["Fire Safety Officer "],
    //     },
    //     {
    //       type: "First Aid",
    //       names: ["First Aid"],
    //     },
    //     {
    //       type: "Public Liability",
    //       names: ["Public Liability Insurance"],
    //     },
    //     {
    //       type: "Work Cover",
    //       names: ["Work Cover", "Expires At"],
    //     },
    //     {
    //       type: "Visa",
    //       names: ["Visa", "Expires At"],
    //     },
    //   ],
    // },
  ];
  public static userDefinedAccreditations = [
    {
      "uuid": "719e9413-d72c-4be6-9770-3800a263002d",
      "template": "2342323532352",
      "type": "Accreditation",
      "roles": [],
      "tags": [
        "Other Organisation Accreditation"
      ],
      "data": "[{\"label\":\"Accreditation Name\",\"type\":\"label\",\"value\":\"Test Accreditation 1\"},{\"label\":\"Description\",\"type\":\"label\",\"value\":\"test1\"},{\"label\":\"Added By\",\"type\":\"label\",\"value\":\"LGM ENTERPRISES PTY. LTD.\"},{\"label\":\"Label\",\"type\":\"label\",\"value\":\"test1\"}]",
      "created_by": "08aa19e2-96cb-4f93-8521-55991b9520b8",
      "creation_date_time": "2025-03-14T08:46:33Z",
      "modifications": [
        {
          "modified_by": "08aa19e2-96cb-4f93-8521-55991b9520b8",
          "modified_date_time": "2025-03-14T08:47:34Z"
        }
      ]
    },
    {
      "uuid": "719e9413-d72c-4be6-9770-3800a263002e",
      "template": "2342323532352",
      "type": "Accreditation",
      "roles": [],
      "tags": [
        "Other Individual Accreditation"
      ],
      "data": "[{\"label\":\"Accreditation Name\",\"type\":\"label\",\"value\":\"Test Accreditation 2\"},{\"label\":\"Description\",\"type\":\"label\",\"value\":\"test2\"},{\"label\":\"Added By\",\"type\":\"label\",\"value\":\"LGM ENTERPRISES PTY. LTD.\"},{\"label\":\"Label\",\"type\":\"label\",\"value\":\"test2\"}]",
      "created_by": "08aa19e2-96cb-4f93-8521-55991b9520b8",
      "creation_date_time": "2025-03-14T08:46:33Z",
      "modifications": [
        {
          "modified_by": "08aa19e2-96cb-4f93-8521-55991b9520b8",
          "modified_date_time": "2025-03-14T08:47:34Z"
        }
      ]
    }
  ]
}
